import { Component, ViewChild, Input } from '@angular/core';
import {PieChartComponent} from '@swimlane/ngx-charts';
import { Portfolio } from '../../models/Portfolio';

/**
 * Generated class for the PortfolioAllocationChartComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'portfolio-allocation-chart',
  templateUrl: 'portfolio-allocation-chart.html'
})
export class PortfolioAllocationChartComponent {
  @ViewChild(PieChartComponent) pieChart: PieChartComponent;
  @Input('portfolio') portfolio: Portfolio;
  @Input('width') width: number;
  @Input('height') height: number;

  legendTitle = "Assets";
  portfolioValue = 0;
  data = [];

  view: any[] = [200, 125];
  colorScheme = {
    domain: [
      '#ffffff',
      '#DADADA',
      '#B6B6B6',
      '#929292',
      '#6C6C6C',
      '#484848',
      '#242424',
      '#000000'
    ]
  };

  constructor() {

  }

  ngOnInit(){
    // this.view = [this.width, this.height]
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.pieChart.margin = [0, 0, 0, 0];
      this.pieChart.update();
    }, 0);

  }

  getResults(){
    if(this.portfolioValue != this.portfolio.getTotalValue()){
      this.portfolioValue = this.portfolio.getTotalValue();
      let allocations = this.portfolio.getAllocations();

      let newData = [];
      for(let asset of allocations){
        newData.push({
          name: asset[0].Name,
          value: asset[1]
        })
      }

      this.data = newData;
    }
    return this.data;
  }

  onSelect(event){
  }
}



// WEBPACK FOOTER //
// ./src/components/portfolio-allocation-chart/portfolio-allocation-chart.ts